
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, ITeamWebsite, IMember, IProfileWebsite, ITeam, MemberService, SanitizedResponse, TeamService } from "../../../../../services";
import { Button, ButtonManageRef, Checkbox, ComposedPassword, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, TabPane, TabPanel, TextAreaInput, TextInput } from "@rivtn/noseur";
import ImportExport from "../../../../page_design/ImportExport";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";

export interface SocialNetworksProps {
    team: ITeam;
    profile: IMember;
    teamWebsite: ITeamWebsite;
}

function SocialNetworks(props: SocialNetworksProps) {

    const { team } = props;
    const teamService = TeamService.getInstance();
    const labels = i18nManager.Labels.teams.settings.general.social_networks;
    if (!props.teamWebsite.social_accounts) props.teamWebsite.social_accounts = {};

    return (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
        <span>{labels.enter_team_usernames}</span>
        {Object.keys(i18nManager.Labels.account.manage_account.social_accounts.accounts_keys).map((accounts_key: string) => (<FormControl key={accounts_key} isFieldset fill style={{ maxWidth: 600, marginTop: 15 }}
            label={(i18nManager.Labels.account.manage_account.social_accounts.accounts_keys as any)[accounts_key]}>
            <TextInput defaultValue={props.teamWebsite.social_accounts?.[accounts_key]}
                onInputComplete={(value) => props.teamWebsite.social_accounts[accounts_key] = value} />
        </FormControl>))}
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 30, padding: "10px 25px", alignSelf: "flex-end" }} onClick={(e) => updateTeamSocialAccounts(e.manageRef)} />
    </div>);

    function updateTeamSocialAccounts(manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        teamService.updateTeamWebsite(team.external_id, props.teamWebsite).then(({ sanitized }: SanitizedResponse<ITeamWebsite>) => {
            props.teamWebsite.social_accounts = sanitized.social_accounts;
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

}

export default SocialNetworks;
